import React  from "react";
import { useTranslation } from 'react-i18next';

import messageLoginImg from "./../../../assets/img/message-login.png";

// Login confirmation function
// Manages successfully pre-register action with social media
export default  function LoginConfirmation() {
    const { t } = useTranslation();
    return (
        <div className="LoginConfirmation">
            <div className="image">
                <img src={messageLoginImg} alt="Message Login" />
            </div>
            <div className="text">
                <h2>{t('LOGIN.TITLE')}</h2>
                <p>{t('LOGIN.DESCRIPTION')}</p>
            </div>
        </div>
    );
}
